import { computed } from 'vue';

import { propsFactory } from '@components/utils';

import type { ComputedRef, PropType } from 'vue';

export type TColor = typeof allowedColor[number];

export type TPrimitiveColors = {
  [key in TColor]: {
    background: string;
    color: string;
    hover: string;
  };
};

export type IColorProps = {
  color: TColor;
};

export interface IUseColor {
  colorInline: ComputedRef<{ background: string; color: string; hover: string }>;
}

export const allowedColor = [
  'default',
  'chocolate',
  'lemon',
  'lime',
  'cyan',
  'teal',
  'indigo',
  'purple',
  'pink'
] as const;

const primitiveColors: TPrimitiveColors = {
  default: {
    background: 'rgb(var(--cds-color-fill-secondary))',
    color: 'rgb(var(--cds-color-content-primary))',
    hover: 'rgb(var(--cds-color-fill-secondary-hover))'
  },
  chocolate: {
    background: 'rgb(var(--cds-color-other-chocolate-fill))',
    color: 'rgb(var(--cds-color-other-chocolate-content))',
    hover: 'rgb(var(--cds-color-other-chocolate-fill-hover))'
  },
  lemon: {
    background: 'rgb(var(--cds-color-other-lemon-fill))',
    color: 'rgb(var(--cds-color-other-lemon-content))',
    hover: 'rgb(var(--cds-color-other-lemon-fill-hover))'
  },
  lime: {
    background: 'rgb(var(--cds-color-other-lime-fill))',
    color: 'rgb(var(--cds-color-other-lime-content))',
    hover: 'rgb(var(--cds-color-other-lime-fill-hover))'
  },
  cyan: {
    background: 'rgb(var(--cds-color-other-cyan-fill))',
    color: 'rgb(var(--cds-color-other-cyan-content))',
    hover: 'rgb(var(--cds-color-other-cyan-fill-hover))'
  },
  teal: {
    background: 'rgb(var(--cds-color-other-teal-fill))',
    color: 'rgb(var(--cds-color-other-teal-content))',
    hover: 'rgb(var(--cds-color-other-teal-fill-hover))'
  },
  indigo: {
    background: 'rgb(var(--cds-color-other-indigo-fill))',
    color: 'rgb(var(--cds-color-other-indigo-content))',
    hover: 'rgb(var(--cds-color-other-indigo-fill-hover))'
  },
  purple: {
    background: 'rgb(var(--cds-color-other-purple-fill))',
    color: 'rgb(var(--cds-color-other-purple-content))',
    hover: 'rgb(var(--cds-color-other-purple-fill-hover))'
  },
  pink: {
    background: 'rgb(var(--cds-color-other-pink-fill))',
    color: 'rgb(var(--cds-color-other-pink-content))',
    hover: 'rgb(var(--cds-color-other-pink-fill-hover))'
  }
};

export const makeColorProps = propsFactory(
  {
    /**
     * Цвет
     */
    color: {
      type: String as PropType<TColor>,
      available: allowedColor,
      default: 'default',
      validator: (value: TColor) => allowedColor.includes(value)
    }
  },
  'color'
);

export function useColor(props: IColorProps, name: string): IUseColor {
  const colorInline = computed(() => primitiveColors[props.color] || primitiveColors.default);

  return { colorInline };
}
